import toolkit from "./toolkit"

const aiApiURL = '/aiInterview/'
const examApiURL = '/onlineExam/'
const groupApiURL = '/interview/groupVideo/'
export default {
  video: {
    changeVideoMode: "/interview/rtm/changeVideoMode",
    flushVideoMode: "/interview/rtm/flushVideoMode",
  },
  upload: {
    common: toolkit.goApiPath("/rc/agent/anonymous/upload")
  },
  ai: {
    connect: aiApiURL + 'candidate/connect',
    join: aiApiURL + 'candidate/join',
    get: aiApiURL + 'candidate/get',
    start: aiApiURL + 'candidate/start',
    stop: aiApiURL + 'candidate/stop',
    upload: aiApiURL + 'common/uploadOss',
    playInfo: aiApiURL + 'common/getPlayInfo',
    playAuth: aiApiURL + 'common/getPlayAuth',
    createUploadVideo: aiApiURL + 'common/createUploadVideo',
    saveVideo: aiApiURL + 'candidate/saveVideo',
    submitAnswer: aiApiURL + 'candidate/submitAnswer',
    showQuestion: aiApiURL + 'candidate/showQuestion',
  },
  exam: {
    get: examApiURL + 'exam/get',
    resort: examApiURL + 'question/resort',
    questionList: examApiURL + 'question/list',
    addCandidate: examApiURL + 'exam/mAddCandidate',
    updateCandidate: examApiURL + 'exam/updateCandidate',
    getExelTemplate: examApiURL + 'excel/exportStdExam',
    notice: examApiURL + 'exam/sendMessage',
    getCandidate: examApiURL + 'exam/getCandidate',
    watchMobileOnline: examApiURL + 'candidate/mobileOnlineCheck',
  },
  question: {
    list: examApiURL + 'question/list',
    delete: examApiURL + 'question/delete'
  },
  questionExam: {
    setList: examApiURL + 'questionExam/setList',
    update: examApiURL + 'questionExam/update',
    delete: examApiURL + 'questionExam/delete',
    add: examApiURL + 'questionExam/addOne',
  },
  test: {
    connect: examApiURL + 'candidate/connect',
    secretConnect: examApiURL + "candidate/connectCandidate",
    create: examApiURL + 'candidate/create',
    update: examApiURL + 'candidate/update',
    get: examApiURL + 'candidate/get',
    savePhoto: examApiURL + 'candidate/savePhoto',
    submitOne: examApiURL + 'candidate/submitOne',
    submit: examApiURL + 'candidate/submit',
    log: examApiURL + 'candidate/log',
  },
  audit: {
    candidateAnswer: examApiURL + 'audit/candidateAnswer',
    candidatePhoto: examApiURL + 'audit/candidatePhoto',
    updateQuestion: examApiURL + 'audit/updateQuestion',
    updateCandidate: examApiURL + 'audit/updateCandidate',
    grade: examApiURL + 'audit/candidateReport'
  },
  group: {
    create: groupApiURL + 'create',
    addMember: groupApiURL + 'addMember',
    update: groupApiURL + 'update',
    close: groupApiURL + 'close',
    delete: groupApiURL + 'delete',
    get: groupApiURL + 'get',
    list: groupApiURL + 'list',
    updateMember: groupApiURL + 'updateMember',
    join: groupApiURL + 'join',
    newViRoom: groupApiURL + 'newViRoom',
    closeViRoom: groupApiURL + 'closeViRoom',
    inviteViRoom: groupApiURL + 'inviteViRoom',
    ready: groupApiURL + 'ready',
    leave: groupApiURL + 'leave',
    muteViRoom: groupApiURL + 'muteViRoom',
    removeViRoom: groupApiURL + 'removeViRoom',
    callCandidate: groupApiURL + 'sendMessage',
  }

}



// WEBPACK FOOTER //
// ./src/util/api.js